import { useCallback, useState } from 'react'
import { useCrypto } from '@/infra/crypto'
import type { KeyRingStatus } from '@/infra/crypto'
import type { EncryptionKey, StorageMode } from '@/infra/crypto/key-ring'

export interface UseEncryptionSettingsReturn {
  readonly keyRingStatus: KeyRingStatus
  readonly activeKeyVersion: number | null
  readonly storageMode: StorageMode
  readonly keys: readonly EncryptionKey[]
  readonly isRotating: boolean
  readonly rotateKey: () => Promise<void>
  readonly setStorageMode: (mode: StorageMode) => void
  readonly exportKeyRing: () => void
  readonly importKeyRing: (file: File) => Promise<void>
}

export function useEncryptionSettings(): UseEncryptionSettingsReturn {
  const crypto = useCrypto()
  const [isRotating, setIsRotating] = useState(false)

  const rotateKey = useCallback(async () => {
    setIsRotating(true)
    try {
      await crypto.rotateKey()
      crypto.exportKeyRing()
    } finally {
      setIsRotating(false)
    }
  }, [crypto])

  return {
    keyRingStatus: crypto.keyRingStatus,
    activeKeyVersion: crypto.activeKeyVersion,
    storageMode: crypto.storageMode,
    keys: crypto.keys,
    isRotating,
    rotateKey,
    setStorageMode: crypto.setStorageMode,
    exportKeyRing: crypto.exportKeyRing,
    importKeyRing: crypto.importKeyRing,
  }
}
